export const amorphSelect = {
    amorphSelect: {
    selectOption: 'Select an option',
    customValue: 'Custom Value',
    }
  };